import React from 'react';
import { MapPin } from 'lucide-react';
import { CITIES } from '../mock';

export default function Cities() {
  return (
    <section id="cities" className="bg-white py-24 md:py-32">
      <div className="max-w-[1280px] mx-auto px-5 md:px-8">
        <div className="flex flex-col md:flex-row md:items-end justify-between gap-6">
          <div className="max-w-2xl">
            <span className="text-[11px] font-semibold tracking-[0.18em] text-[#FF6A1A]">AVAILABLE ACROSS INDIA</span>
            <h2 className="mt-3 text-[34px] md:text-[46px] font-semibold tracking-[-0.02em] text-[#0f0f10]">
              Started in Bangalore,
              <br className="hidden md:block" /> now in every metro
            </h2>
          </div>
          <p className="text-[14.5px] text-[#6b6b70] max-w-sm">
            We launch each city only after weeks of training drivers on safety, etiquette, and fair pricing.
          </p>
        </div>

        <div className="mt-14 grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-3">
          {CITIES.map((c, i) => (
            <div
              key={c.name}
              className="group relative bg-[#f7f7f5] hover:bg-[#0f0f10] rounded-2xl p-5 border border-black/[0.04] transition-colors duration-300 cursor-pointer overflow-hidden"
            >
              <div className="flex items-start gap-3">
                <div className="w-9 h-9 rounded-lg bg-white group-hover:bg-[#FF6A1A]/15 grid place-items-center text-[#0f0f10] group-hover:text-[#FF6A1A] transition-colors">
                  <MapPin size={16} />
                </div>
                <div className="min-w-0">
                  <div className="text-[15px] font-semibold text-[#0f0f10] group-hover:text-white transition-colors">
                    {c.name}
                  </div>
                  <div className="text-[11.5px] text-[#6b6b70] group-hover:text-white/60 transition-colors tracking-wide">
                    {c.tag}
                  </div>
                </div>
              </div>
              <span className="absolute top-3 right-4 text-[10px] font-semibold text-[#c4c4c6] group-hover:text-[#FF6A1A] transition-colors">
                {String(i + 1).padStart(2, '0')}
              </span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
